import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'components/Modal/Modal';
import styles from './FilterModal.module.scss';
import FacetSelector from './FacetSelector';
import LocationSelector from './LocationSelector';

const ClearButton = ({ search }) => {
  const handleClear = () => {
    if (search && search.helper) {
      search.helper.clearRefinements().search();
    }
  };

  return (
    <button type="button" className={styles.clearButton} onClick={handleClear}>
      Clear all filters
    </button>
  );
};

ClearButton.propTypes = {
  search: PropTypes.object,
};

const FilterModal = ({ search, isOpen, onClose }) => (
  <Modal
    show={isOpen}
    onExit={onClose}
    backgroundExit
    closeButton
    modalClassName={styles.modalOverride}
  >
    <div className={styles.modalContent}>
      <h2 className={styles.modalTitle}>Filters</h2>
      <p className={styles.modalSubtitle}>
        Refine your search to find the perfect expert
      </p>
    </div>

    <div className={styles.body}>
      <section className={styles.section}>
        <h3 className={styles.sectionTitle}>Roles</h3>
        <FacetSelector
          search={search}
          attribute="roles"
          placeholder="Type to search roles…"
        />
      </section>

      <section className={styles.section}>
        <h3 className={styles.sectionTitle}>Skills</h3>
        <FacetSelector
          search={search}
          attribute="skills"
          placeholder="Type to search skills…"
        />
      </section>

      <section className={styles.section}>
        <h3 className={styles.sectionTitle}>Location</h3>
        <LocationSelector search={search} />
      </section>

      <section className={styles.section}>
        <h3 className={styles.sectionTitle}>Industries</h3>
        <FacetSelector
          search={search}
          attribute="sectors"
          placeholder="Type to search industries…"
          showSuggestions={false}
        />
      </section>
    </div>

    <div className={styles.footer}>
      <ClearButton search={search} />
      <button className={styles.applyBtn} onClick={onClose}>
        Apply filters
      </button>
    </div>
  </Modal>
);

FilterModal.propTypes = {
  search: PropTypes.object,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default FilterModal;
